/**
 * Custom error codes which the backend can throw in case of failing operations.
 * It has a map on the frontend where these codes are mapped to translation keys.
 * Please make sure to always update that file as well when adding new keys!
 * Path: apps/capacitor-frontend/src/app/utils/errorMessages.ts
 * If you wanna help the frontend guys, please also add the new translation keys to the de.json file :)
 */
export enum ErrorCode {
  SUGGESTION_NOT_FOUND = 'SUGGESTION_NOT_FOUND',
  ADDRESS_DATA_NOT_FOUND = 'ADDRESS_DATA_NOT_FOUND',
  ADDRESS_DATA_CAN_NOT_BE_CREATED = 'ADDRESS_DATA_CAN_NOT_BE_CREATED',
  ADDRESS_DATA_CAN_NOT_BE_UPDATED = 'ADDRESS_DATA_CAN_NOT_BE_UPDATED',
  ADDRESS_DATA_CAN_NOT_BE_DELETED = 'ADDRESS_DATA_CAN_NOT_BE_DELETED',
  ADDRESS_DATA_CAN_NOT_BE_RESTORED = 'ADDRESS_DATA_CAN_NOT_BE_RESTORED',
  BIOGRAPHY_NOT_FOUND = 'BIOGRAPHY_NOT_FOUND',
  BIOGRAPHY_CAN_NOT_BE_CREATED = 'BIOGRAPHY_CAN_NOT_BE_CREATED',
  BIOGRAPHY_CAN_NOT_BE_UPDATED = 'BIOGRAPHY_CAN_NOT_BE_UPDATED',
  BIOGRAPHY_CAN_NOT_BE_DELETED = 'BIOGRAPHY_CAN_NOT_BE_DELETED',
  CARE_PLAN_NOT_FOUND = 'CARE_PLAN_NOT_FOUND',
  CARE_PLAN_CAN_NOT_BE_CREATED = 'CARE_PLAN_CAN_NOT_BE_CREATED',
  CARE_PLAN_CAN_NOT_BE_UPDATED = 'CARE_PLAN_CAN_NOT_BE_UPDATED',
  CARE_PLAN_CAN_NOT_BE_DELETED = 'CARE_PLAN_CAN_NOT_BE_DELETED',
  CLIENT_NOT_FOUND = 'CLIENT_NOT_FOUND',
  CLIENT_CAN_NOT_BE_CREATED = 'CLIENT_CAN_NOT_BE_CREATED',
  CLIENT_CAN_NOT_BE_UPDATED = 'CLIENT_CAN_NOT_BE_UPDATED',
  CLIENT_CAN_NOT_BE_DELETED = 'CLIENT_CAN_NOT_BE_DELETED',
  COMMUNICATION_DATA_NOT_FOUND = 'COMMUNICATION_DATA_NOT_FOUND',
  COMMUNICATION_DATA_CAN_NOT_BE_CREATED = 'COMMUNICATION_DATA_CAN_NOT_BE_CREATED',
  COMMUNICATION_DATA_CAN_NOT_BE_UPDATED = 'COMMUNICATION_DATA_CAN_NOT_BE_UPDATED',
  COMMUNICATION_DATA_CAN_NOT_BE_DELETED = 'COMMUNICATION_DATA_CAN_NOT_BE_DELETED',
  COMMUNICATION_DATA_CAN_NOT_BE_RESTORED = 'COMMUNICATION_DATA_CAN_NOT_BE_RESTORED',
  CONSULTATION_NOT_FOUND = 'CONSULTATION_NOT_FOUND',
  CONSULTATION_CAN_NOT_BE_CREATED = 'CONSULTATION_CAN_NOT_BE_CREATED',
  CONSULTATION_CAN_NOT_BE_UPDATED = 'CONSULTATION_CAN_NOT_BE_UPDATED',
  CONSULTATION_CAN_NOT_BE_DELETED = 'CONSULTATION_CAN_NOT_BE_DELETED',
  CONTACT_DATA_NOT_FOUND = 'CONTACT_DATA_NOT_FOUND',
  CONTACT_DATA_CAN_NOT_BE_CREATED = 'CONTACT_DATA_CAN_NOT_BE_CREATED',
  CONTACT_DATA_CAN_NOT_BE_UPDATED = 'CONTACT_DATA_CAN_NOT_BE_UPDATED',
  CONTACT_DATA_CAN_NOT_BE_DELETED = 'CONTACT_DATA_CAN_NOT_BE_DELETED',
  CONTACT_DATA_CAN_NOT_BE_RESTORED = 'CONTACT_DATA_CAN_NOT_BE_RESTORED',
  DECUBITUS_RISK_FORM_NOT_FOUND = 'DECUBITUS_RISK_FORM_NOT_FOUND',
  DECUBITUS_RISK_FORM_CAN_NOT_BE_CREATED = 'DECUBITUS_RISK_FORM_CAN_NOT_BE_CREATED',
  DECUBITUS_RISK_FORM_CAN_NOT_BE_UPDATED = 'DECUBITUS_RISK_FORM_CAN_NOT_BE_UPDATED',
  DECUBITUS_RISK_FORM_CAN_NOT_BE_DELETED = 'DECUBITUS_RISK_FORM_CAN_NOT_BE_DELETED',
  DOCTOR_NOT_FOUND = 'DOCTOR_NOT_FOUND',
  DOCTOR_CAN_NOT_BE_CREATED = 'DOCTOR_CAN_NOT_BE_CREATED',
  DOCTOR_DIAGNOSIS_NOT_FOUND = 'DOCTOR_DIAGNOSIS_NOT_FOUND',
  DOCTOR_DIAGNOSIS_CAN_NOT_BE_CREATED = 'DOCTOR_DIAGNOSIS_CAN_NOT_BE_CREATED',
  EMPLOYEE_BASE_DATA_NOT_FOUND = 'EMPLOYEE_BASE_DATA_NOT_FOUND',
  EMPLOYEE_BASE_DATA_CAN_NOT_BE_CREATED = 'EMPLOYEE_BASE_DATA_CAN_NOT_BE_CREATED',
  EMPLOYEE_BASE_DATA_CAN_NOT_BE_UPDATED = 'EMPLOYEE_BASE_DATA_CAN_NOT_BE_UPDATED',
  EMPLOYEE_BASE_DATA_CAN_NOT_BE_DELETED = 'EMPLOYEE_BASE_DATA_CAN_NOT_BE_DELETED',
  EMPLOYEE_BASE_DATA_CAN_NOT_BE_RESTORED = 'EMPLOYEE_BASE_DATA_CAN_NOT_BE_RESTORED',
  EMPLOYEE_NOT_FOUND = 'EMPLOYEE_NOT_FOUND',
  EMPLOYEE_CAN_NOT_BE_CREATED = 'EMPLOYEE_CAN_NOT_BE_CREATED',
  EMPLOYEE_CAN_NOT_BE_UPDATED = 'EMPLOYEE_CAN_NOT_BE_UPDATED',
  EMPLOYEE_CAN_NOT_BE_DELETED = 'EMPLOYEE_CAN_NOT_BE_DELETED',
  EMPLOYEE_CAN_NOT_BE_RESTORED = 'EMPLOYEE_CAN_NOT_BE_RESTORED',
  EMPLOYEE_CONTRACT_CHECKLIST_NOT_FOUND = 'EMPLOYEE_CONTRACT_CHECKLIST_NOT_FOUND',
  EMPLOYEE_ALREADY_EXISTS_IN_TIMEOS = 'EMPLOYEE_ALREADY_EXISTS_IN_TIMEOS',
  EMPLOYEE_COULD_NOT_BE_CREATED_IN_TIMEOS = 'EMPLOYEE_COULD_NOT_BE_CREATED_IN_TIMEOS',
  EMPLOYEE_LOGIN_CREDENTIALS_COULD_NOT_BE_SET_IN_TIMEOS = 'EMPLOYEE_LOGIN_CREDENTIALS_COULD_NOT_BE_SET_IN_TIMEOS',
  EMPLOYEE_COULD_NOT_BE_UPDATED_IN_TIMEOS = 'EMPLOYEE_COULD_NOT_BE_UPDATED_IN_TIMEOS',
  EMPLOYEE_COULD_NOT_BE_DELETED_IN_TIMEOS = 'EMPLOYEE_COULD_NOT_BE_DELETED_IN_TIMEOS',
  EMPLOYEE_COULD_NOT_BE_RESTORED_IN_TIMEOS = 'EMPLOYEE_COULD_NOT_BE_RESTORED_IN_TIMEOS',
  EMPLOYEE_QUALIFICATION_COULD_NOT_BE_ADDED_IN_TIMEOS = 'EMPLOYEE_QUALIFICATION_COULD_NOT_BE_ADDED_IN_TIMEOS',
  EXECUTION_PROOF_NO_PERMISSION = 'EXECUTION_PROOF_NO_PERMISSION',
  FALL_NOT_FOUND = 'FALL_NOT_FOUND',
  FALLS_NOT_FOUND = 'FALLS_NOT_FOUND',
  FALL_CAN_NOT_BE_CREATED = 'FALL_CAN_NOT_BE_CREATED',
  FALL_CAN_NOT_BE_UPDATED = 'FALL_CAN_NOT_BE_UPDATED',
  FALL_CAN_NOT_BE_DELETED = 'FALL_CAN_NOT_BE_DELETED',
  FALL_RISK_FORM_NOT_FOUND = 'FALL_RISK_FORM_NOT_FOUND',
  FALL_RISK_FORM_CAN_NOT_BE_UPDATED = 'FALL_RISK_FORM_CAN_NOT_BE_UPDATED',
  FALL_RISK_FORM_CAN_NOT_BE_CREATED = 'FALL_RISK_FORM_CAN_NOT_BE_CREATED',
  FALL_PROTOCOL_FORM_NOT_FOUND = 'FALL_PROTOCOL_FORM_NOT_FOUND',
  FALL_PROTOCOL_FORM_CAN_NOT_BE_CREATED = 'FALL_PROTOCOL_FORM_CAN_NOT_BE_CREATED',
  FALL_PROTOCOL_FORM_CAN_NOT_BE_UPDATED = 'FALL_PROTOCOL_FORM_CAN_NOT_BE_UPDATED',
  FALL_PROTOCOL_FORM_CAN_NOT_BE_DELETED = 'FALL_PROTOCOL_FORM_CAN_NOT_BE_DELETED',
  NAME_NOT_FOUND = 'NAME_NOT_FOUND',
  NAME_CAN_NOT_BE_CREATED = 'NAME_CAN_NOT_BE_CREATED',
  NAME_CAN_NOT_BE_UPDATED = 'NAME_CAN_NOT_BE_UPDATED',
  NAME_CAN_NOT_BE_DELETED = 'NAME_CAN_NOT_BE_DELETED',
  NAME_CAN_NOT_BE_RESTORED = 'NAME_CAN_NOT_BE_RESTORED',
  NURSE_VISIT_NOT_FOUND = 'NURSE_VISIT_NOT_FOUND',
  NURSE_VISIT_CAN_NOT_BE_CREATED = 'NURSE_VISIT_CAN_NOT_BE_CREATED',
  NURSE_VISIT_CAN_NOT_BE_UPDATED = 'NURSE_VISIT_CAN_NOT_BE_UPDATED',
  NURSING_HOME_NOT_FOUND = 'NURSING_HOME_NOT_FOUND',
  NURSING_HOME_NOT_FOUND_BY_CLIENT_ID = 'NURSING_HOME_NOT_FOUND_BY_CLIENT_ID',
  NURSING_HOME_ALREADY_EXISTS = 'NURSING_HOME_ALREADY_EXISTS',
  NURSING_HOME_CAN_NOT_BE_CREATED = 'NURSING_HOME_CAN_NOT_BE_CREATED',
  PERSONAL_DATA_NOT_FOUND = 'PERSONAL_DATA_NOT_FOUND',
  PERSONAL_DATA_CAN_NOT_BE_CREATED = 'PERSONAL_DATA_CAN_NOT_BE_CREATED',
  PERSONAL_DATA_CAN_NOT_BE_UPDATED = 'PERSONAL_DATA_CAN_NOT_BE_UPDATED',
  PERSONAL_DATA_CAN_NOT_BE_DELETED = 'PERSONAL_DATA_CAN_NOT_BE_DELETED',
  PERSONAL_DATA_CAN_NOT_BE_RESTORED = 'PERSONAL_DATA_CAN_NOT_BE_RESTORED',
  RESIDENT_NOT_FOUND = 'RESIDENT_NOT_FOUND',
  RESIDENTS_NOT_FOUND = 'RESIDENTS_NOT_FOUND',
  RESIDENT_CAN_NOT_BE_CREATED = 'RESIDENT_CAN_NOT_BE_CREATED',
  RESIDENT_CAN_NOT_BE_UPDATED = 'RESIDENT_CAN_NOT_BE_UPDATED',
  RESIDENT_CAN_NOT_BE_DELETED = 'RESIDENT_CAN_NOT_BE_DELETED',
  RESIDENT_CAN_NOT_BE_RESTORED = 'RESIDENT_CAN_NOT_BE_RESTORED',
  RESIDENT_BASE_DATA_NOT_FOUND = 'RESIDENT_BASE_DATA_NOT_FOUND',
  RESIDENT_BASE_DATA_CAN_NOT_BE_CREATED = 'RESIDENT_BASE_DATA_CAN_NOT_BE_CREATED',
  RESIDENT_BASE_DATA_CAN_NOT_BE_UPDATED = 'RESIDENT_BASE_DATA_CAN_NOT_BE_UPDATED',
  RESIDENT_BASE_DATA_CAN_NOT_BE_DELETED = 'RESIDENT_BASE_DATA_CAN_NOT_BE_DELETED',
  RESIDENT_BASE_DATA_CAN_NOT_BE_RESTORED = 'RESIDENT_BASE_DATA_CAN_NOT_BE_RESTORED',
  RESIDENT_ADVICE_CONSULTATION_NOT_FOUND = 'RESIDENT_ADVICE_CONSULTATION_NOT_FOUND',
  RESIDENT_ADVICE_CONSULTATION_CAN_NOT_BE_CREATED = 'RESIDENT_ADVICE_CONSULTATION_CAN_NOT_BE_CREATED',
  RESIDENT_ADVICE_CONSULTATION_CAN_NOT_BE_UPDATED = 'RESIDENT_ADVICE_CONSULTATION_CAN_NOT_BE_UPDATED',
  RESIDENT_ADVICE_CONSULTATION_CAN_NOT_BE_DELETED = 'RESIDENT_ADVICE_CONSULTATION_CAN_NOT_BE_DELETED',
  RESIDENT_ADVICE_CONSULTATION_CAN_NOT_BE_RESTORED = 'RESIDENT_ADVICE_CONSULTATION_CAN_NOT_BE_RESTORED',
  RESIDENT_WITH_INVOICE_CAN_NOT_BE_DELETED = 'RESIDENT_WITH_INVOICE_CAN_NOT_BE_DELETED',
  INTERRUPTION_NOT_FOUND = 'INTERRUPTION_NOT_FOUND',
  HOUSE_DIVISION_CAN_NOT_BE_CREATED = 'HOUSE_DIVISION_CAN_NOT_BE_CREATED',
  HOUSE_DIVISION_CAN_NOT_BE_FOUND = 'HOUSE_DIVISION_CAN_NOT_BE_FOUND',
  HOUSE_DIVISION_CAN_NOT_BE_UPDATED = 'HOUSE_DIVISION_CAN_NOT_BE_UPDATED',
  HOUSE_DIVISION_CAN_NOT_BE_DELETED = 'HOUSE_DIVISION_CAN_NOT_BE_DELETED',
  LABEL_COULD_NOT_BE_GENERATED = 'LABEL_COULD_NOT_BE_GENERATED',
  RESIDENT_CAN_ONLY_BE_ATTACHED_TO_BED = 'RESIDENT_CAN_ONLY_BE_ATTACHED_TO_BED',
  VITALE_NOT_FOUND = 'VITALE_NOT_FOUND',
  VITALE_CAN_NOT_BE_CREATED = 'VITALE_CAN_NOT_BE_CREATED',
  VITALE_CAN_NOT_BE_UPDATED = 'VITALE_CAN_NOT_BE_UPDATED',
  VITALE_CAN_NOT_BE_DELETED = 'VITALE_CAN_NOT_BE_DELETED',
  DEADLINES_CAN_NOT_BE_CREATED = 'DEADLINES_CAN_NOT_BE_CREATED',
  DEADLINES_CAN_NOT_BE_UPDATED = 'DEADLINES_CAN_NOT_BE_UPDATED',
  DEADLINES_CAN_NOT_BE_FILTERED = 'DEADLINES_CAN_NOT_BE_FILTERED',
  DEADLINES_NOT_FOUND = 'DEADLINES_NOT_FOUND',
  DEADLINES_CAN_NOT_BE_RETRIEVED_AQUA = 'DEADLINES_CAN_NOT_BE_RETRIEVED_AQUA',
  INDICATOR_RECORD_CAN_NOT_BE_CREATED = 'INDICATOR_RECORD_CAN_NOT_BE_CREATED',
  INDICATOR_RESIDENT_RECORD_CAN_NOT_BE_CREATED = 'INDICATOR_RESIDENT_RECORD_CAN_NOT_BE_CREATED',
  INDICATOR_RESIDENT_RECORD_CAN_NOT_BE_CREATED_FROM_OVERVIEW = 'INDICATOR_RESIDENT_RECORD_CAN_NOT_BE_CREATED_FROM_OVERVIEW ',
  INDICATORS_CAN_NOT_BE_PROCESSED = 'INDICATORS_CAN_NOT_BE_PROCESSED',
  INDICATORS_VALIDATION_PROTOCOL_ERROR = 'INDICATORS_VALIDATION_PROTOCOL_ERROR',
  INDICATORS_COMMENTATION_ERROR = 'INDICATORS_COMMENTATION_ERROR',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_CAN_NOT_BE_CREATED = 'USER_CAN_NOT_BE_CREATED',
  USER_CAN_NOT_BE_UPDATED = 'USER_CAN_NOT_BE_UPDATED',
  USER_CAN_NOT_BE_DELETED = 'USER_CAN_NOT_BE_DELETED',
  USER_CAN_NOT_BE_RESTORED = 'USER_CAN_NOT_BE_RESTORED',
  USERS_CAN_NOT_BE_LOADED = 'USERS_CAN_NOT_BE_LOADED',
  PASSWORD_CAN_NOT_BE_SET = 'PASSWORD_CAN_NOT_BE_SET',
  PASSWORD_CAN_NOT_BE_RESET = 'PASSWORD_CAN_NOT_BE_RESET',
  PIN_CAN_NOT_BE_SET = 'PIN_CAN_NOT_BE_SET',
  SYSTEM_ACCESS_CAN_NOT_BE_UPDATED = 'SYSTEM_ACCESS_CAN_NOT_BE_UPDATED',
  SUPERVISOR_DATA_NOT_FOUND = 'SUPERVISOR_DATA_NOT_FOUND',
  SUPERVISOR_DATA_CAN_NOT_BE_CREATED = 'SUPERVISOR_DATA_CAN_NOT_BE_CREATED',
  SUPERVISOR_DATA_CAN_NOT_BE_UPDATED = 'SUPERVISOR_DATA_CAN_NOT_BE_UPDATED',
  SUPERVISOR_DATA_CAN_NOT_BE_DELETED = 'SUPERVISOR_DATA_CAN_NOT_BE_DELETED',
  RELATIVE_CARE_IDS_COULD_NOT_BE_SAVED = 'RELATIVE_CARE_IDS_COULD_NOT_BE_SAVED',
  RELATIVE_MANDATE_IDS_COULD_NOT_BE_SAVED = 'RELATIVE_MANDATE_IDS_COULD_NOT_BE_SAVED',
  RELATIVE_MANDATE_NOT_FOUND = 'RELATIVE_MANDATE_NOT_FOUND',
  RELATIVE_MANDATE_CAN_NOT_BE_CREATED = 'RELATIVE_MANDATE_CAN_NOT_BE_CREATED',
  RELATIVE_MANDATE_CAN_NOT_BE_UPDATED = 'RELATIVE_MANDATE_CAN_NOT_BE_UPDATED',
  RELATIVE_MANDATE_CAN_NOT_BE_DELETED = 'RELATIVE_MANDATE_CAN_NOT_BE_DELETED',
  RELATIVE_CONTACT_NOT_FOUND = 'RELATIVE_CONTACT_NOT_FOUND',
  RELATIVE_CONTACT_CAN_NOT_BE_CREATED = 'RELATIVE_CONTACT_CAN_NOT_BE_CREATED',
  RELATIVE_CONTACT_CAN_NOT_BE_UPDATED = 'RELATIVE_CONTACT_CAN_NOT_BE_UPDATED',
  RELATIVE_CONTACT_CAN_NOT_BE_DELETED = 'RELATIVE_CONTACT_CAN_NOT_BE_DELETED',
  RELATIVE_CARE_NOT_FOUND = 'RELATIVE_CARE_NOT_FOUND',
  RELATIVE_CARE_CAN_NOT_BE_CREATED = 'RELATIVE_CARE_CAN_NOT_BE_CREATED',
  RELATIVE_CARE_CAN_NOT_BE_UPDATED = 'RELATIVE_CARE_CAN_NOT_BE_UPDATED',
  RELATIVE_CARE_CAN_NOT_BE_DELETED = 'RELATIVE_CARE_CAN_NOT_BE_DELETED',
  NURSING_TASK_CANNOT_BE_CREATED = 'NURSING_TASK_CANNOT_BE_CREATED',
  NURSING_TASK_NOT_FOUND = 'NURSING_TASK_NOT_FOUND',
  NURSING_TASK_DOCUMENTATION_NOT_FOUND = 'NURSING_TASK_DOCUMENTATION_NOT_FOUND',
  NURSING_TASK_SUGGESTION_NOT_FOUND = 'NURSING_TASK_SUGGESTION_NOT_FOUND',
  NURSING_TASK_SUGGESTION_CANNOT_BE_CREATED = 'NURSING_TASK_SUGGESTION_CANNOT_BE_CREATED',
  NURSING_TASK_SUGGESTIONS_CAN_NOT_BE_LOADED = 'NURSING_TASK_SUGGESTIONS_CAN_NOT_BE_LOADED',
  NURSING_TASK_SUGGESTION_CANNOT_BE_UPDATED = 'NURSING_TASK_SUGGESTION_CANNOT_BE_UPDATED',
  NURSING_TASK_SUGGESTION_CANNOT_BE_DELETED = 'NURSING_TASK_SUGGESTION_CANNOT_BE_DELETED',
  EXECUTION_PROOF_DOCUMENTATION_NOT_FOUND = 'EXECUTION_PROOF_DOCUMENTATION_NOT_FOUND',
  RESIDENT_GROUP_NOT_FOUND = 'RESIDENT_GROUP_NOT_FOUND',
  VITAL_SIGN_NOT_FOUND = 'VITAL_SIGN_NOT_FOUND',
  VITAL_SIGN_CAN_NOT_BE_CREATED = 'VITAL_SIGN_CAN_NOT_BE_CREATED',
  VITAL_SIGN_CAN_NOT_BE_UPDATED = 'VITAL_SIGN_CAN_NOT_BE_UPDATED',
  VITAL_SIGN_CAN_NOT_BE_DELETED = 'VITAL_SIGN_CAN_NOT_BE_DELETED',
  RESIDENT_CAN_NOT_BE_ADDED_TO_RESIDENT_GROUP = 'RESIDENT_CAN_NOT_BE_ADDED_TO_RESIDENT_GROUP',
  RESIDENT_GROUP_CANNOT_BE_CREATED = 'RESIDENT_GROUP_CANNOT_BE_CREATED',
  RESIDENT_GROUP_CANNOT_BE_UPDATED = 'RESIDENT_GROUP_CANNOT_BE_UPDATED',
  RESIDENT_GROUP_CAN_NOT_BE_RESTORED = 'RESIDENT_GROUP_CAN_NOT_BE_RESTORED',
  RESIDENT_GROUP_CANNOT_BE_DELETED = 'RESIDENT_GROUP_CANNOT_BE_DELETED',
  REFERENCE_RESIDENT_GROUP_CAN_NOT_BE_CREATED = 'REFERENCE_RESIDENT_GROUP_CAN_NOT_BE_CREATED',
  PRESCRIPTION_NOT_FOUND = 'PRESCRIPTION_NOT_FOUND',
  PRESCRIPTION_CAN_NOT_BE_CREATED = 'PRESCRIPTION_CAN_NOT_BE_CREATED',
  PRESCRIPTION_CAN_NOT_BE_UPDATED = 'PRESCRIPTION_CAN_NOT_BE_UPDATED',
  PRESCRIPTION_CAN_NOT_BE_DELETED = 'PRESCRIPTION_CAN_NOT_BE_DELETED',
  INPUT_MALFORMED = 'INPUT_MALFORMED',
  SOCIAL_CARE_EVENT_NOT_FOUND = 'SOCIAL_CARE_EVENT_NOT_FOUND',
  SOCIAL_CARE_EVENT_CAN_NOT_BE_CREATED = 'SOCIAL_CARE_EVENT_CAN_NOT_BE_CREATED',
  SOCIAL_CARE_EVENT_CAN_NOT_BE_UPDATED = 'SOCIAL_CARE_EVENT_CAN_NOT_BE_UPDATED',
  SOCIAL_CARE_EVENT_CAN_NOT_BE_DELETED = 'SOCIAL_CARE_EVENT_CAN_NOT_BE_DELETED',
  SOCIAL_CARE_EVENT_DOCUMENT_NOT_FOUND = 'SOCIAL_CARE_EVENT_DOCUMENT_NOT_FOUND',
  SOCIAL_CARE_EVENT_DOCUMENT_CAN_NOT_BE_CREATED = 'SOCIAL_CARE_EVENT_DOCUMENT_CAN_NOT_BE_CREATED',
  SOCIAL_CARE_EVENT_DOCUMENT_CAN_NOT_BE_UPDATED = 'SOCIAL_CARE_EVENT_DOCUMENT_CAN_NOT_BE_UPDATED',
  SOCIAL_CARE_EVENT_DOCUMENT_CAN_NOT_BE_DELETED = 'SOCIAL_CARE_EVENT_DOCUMENT_CAN_NOT_BE_DELETED',
  NUTRITION_PROTOCOL_NOT_FOUND = 'NUTRITION_PROTOCOL_NOT_FOUND',
  NUTRITION_PROTOCOL_CAN_NOT_BE_CREATED = 'NUTRITION_PROTOCOL_CAN_NOT_BE_CREATED',
  NUTRITION_PROTOCOL_CAN_NOT_BE_UPDATED = 'NUTRITION_PROTOCOL_CAN_NOT_BE_UPDATED',
  NUTRITION_PROTOCOL_CAN_NOT_BE_DELETED = 'NUTRITION_PROTOCOL_CAN_NOT_BE_DELETED',
  LIQUID_OUTPUT_CAN_NOT_BE_CREATED = 'LIQUID_OUTPUT_CAN_NOT_BE_CREATED',
  LIQUID_OUTPUT_CAN_NOT_BE_DELETED = 'LIQUID_OUTPUT_CAN_NOT_BE_DELETED',
  LIQUID_OUTPUT_CAN_NOT_BE_UPDATED = 'LIQUID_OUTPUT_CAN_NOT_BE_UPDATED',
  LIQUID_OUTPUT_NOT_FOUND = 'LIQUID_OUTPUT_NOT_FOUND',
  MEAL_CAN_NOT_BE_CREATED = 'MEAL_CAN_NOT_BE_CREATED',
  MEAL_CAN_NOT_BE_DELETED = 'MEAL_CAN_NOT_BE_DELETED',
  MEAL_NOT_FOUND = 'MEAL_NOT_FOUND',
  MEAL_CAN_NOT_BE_UPDATED = 'MEAL_CAN_NOT_BE_UPDATED',
  ROLE_NOT_FOUND = 'ROLE_NOT_FOUND',
  PAIN_NOT_FOUND = 'PAIN_NOT_FOUND',
  PAIN_CAN_NOT_BE_CREATED = 'PAIN_CAN_NOT_BE_CREATED',
  PAIN_CAN_NOT_BE_UPDATED = 'PAIN_CAN_NOT_BE_UPDATED',
  PAIN_CAN_NOT_BE_DELETED = 'PAIN_CAN_NOT_BE_DELETED',
  PAIN_ASSESSMENT_NOT_FOUND = 'PAIN_ASSESSMENT_NOT_FOUND',
  PAIN_ASSESSMENT_CAN_NOT_BE_CREATED = 'PAIN_ASSESSMENT_CAN_NOT_BE_CREATED',
  PAIN_ASSESSMENT_CAN_NOT_BE_UPDATED = 'PAIN_ASSESSMENT_CAN_NOT_BE_UPDATED',
  PAIN_ASSESSMENT_CAN_NOT_BE_DELETED = 'PAIN_ASSESSMENT_CAN_NOT_BE_DELETED',
  PAIN_ASSESSMENT_IDS_COULD_NOT_BE_SAVED = 'PAIN_ASSESSMENT_IDS_COULD_NOT_BE_SAVED',
  HINTS_CONFIG_NOT_FOUND = 'HINTS_CONFIG_NOT_FOUND',
  HINTS_CONFIG_CAN_NOT_BE_CREATED = 'HINTS_CONFIG_CAN_NOT_BE_CREATED',
  HINTS_CONFIG_CAN_NOT_BE_DELETED = 'HINTS_CONFIG_CAN_NOT_BE_DELETED',
  VISIT_SHEET_NOT_FOUND = 'VISIT_SHEET_NOT_FOUND',
  VISIT_SHEET_CAN_NOT_BE_CREATED = 'VISIT_SHEET_CAN_NOT_BE_CREATED',
  VISIT_SHEET_CAN_NOT_BE_UPDATED = 'VISIT_SHEET_CAN_NOT_BE_UPDATED',
  VISIT_SHEET_CAN_NOT_BE_DELETED = 'VISIT_SHEET_CAN_NOT_BE_DELETED',
  NURSING_REPORT_CANNOT_BE_UPDATED = 'NURSING_REPORT_CANNOT_BE_UPDATED',
  NURSING_REPORT_NOT_FOUND = 'NURSING_REPORT_NOT_FOUND',
  NURSING_REPORT_CANNOT_BE_CREATED = 'NURSING_REPORT_CANNOT_BE_CREATED',
  NURSING_REPORT_CANNOT_BE_DELETED = 'NURSING_REPORT_CANNOT_BE_DELETED',
  NURSING_REPORTS_NOT_FOUND = 'NURSING_REPORTS_NOT_FOUND',
  IMMUTABLE_DATA = 'IMMUTABLE_DATA',
  TIMEFRAME_EXCEEDED = 'TIMEFRAME_EXCEEDED',
  ON_DEMAND_MEDICATION_CAN_NOT_BE_CREATED = 'ON_DEMAND_MEDICATION_CAN_NOT_BE_CREATED',
  ON_DEMAND_MEDICATION_NOT_FOUND = 'ON_DEMAND_MEDICATION_NOT_FOUND',
  ON_DEMAND_MEDICATION_CAN_NOT_BE_UPDATED = 'ON_DEMAND_MEDICATION_CAN_NOT_BE_UPDATED',
  GENERAL_ORDER_CAN_NOT_BE_UPDATED = 'GENERAL_ORDER_CAN_NOT_BE_UPDATED',
  GENERAL_ORDER_NOT_FOUND = 'GENERAL_ORDER_NOT_FOUND',
  GENERAL_ORDER_CAN_NOT_BE_DELETED = 'GENERAL_ORDER_CAN_NOT_BE_DELETED',
  GENERAL_ORDER_CAN_NOT_BE_CREATED = 'GENERAL_ORDER_CAN_NOT_BE_CREATED',
  INSULIN_MEDICATION_NOT_FOUND = 'INSULIN_MEDICATION_NOT_FOUND',
  INSULIN_MEDICATION_CAN_NOT_BE_CREATED = 'INSULIN_MEDICATION_CAN_NOT_BE_CREATED',
  INSULIN_MEDICATION_CAN_NOT_BE_UPDATED = 'INSULIN_MEDICATION_CAN_NOT_BE_UPDATED',
  CONSTANT_MEDICATION_NOT_FOUND = 'CONSTANT_MEDICATION_NOT_FOUND',
  CONSTANT_MEDICATION_CAN_NOT_BE_CREATED = 'CONSTANT_MEDICATION_CAN_NOT_BE_CREATED',
  CONSTANT_MEDICATION_CAN_NOT_BE_UPDATED = 'CONSTANT_MEDICATION_CAN_NOT_BE_UPDATED',
  PEG_MEDICATION_CAN_NOT_BE_CREATED = 'PEG_MEDICATION_CAN_NOT_BE_CREATED',
  PEG_MEDICATION_NOT_FOUND = 'PEG_MEDICATION_NOT_FOUND',
  PEG_MEDICATION_CAN_NOT_BE_UPDATED = 'PEG_MEDICATION_CAN_NOT_BE_UPDATED',
  PASTORAL_CARE_NOT_FOUND = 'PASTORAL_CARE_NOT_FOUND',
  PASTORAL_CARE_CAN_NOT_BE_CREATED = 'PASTORAL_CARE_CAN_NOT_BE_CREATED',
  PASTORAL_CARE_CAN_NOT_BE_UPDATED = 'PASTORAL_CARE_CAN_NOT_BE_UPDATED',
  PASTORAL_CARE_CAN_NOT_BE_DELETED = 'PASTORAL_CARE_CAN_NOT_BE_DELETED',
  PASTORAL_CARE_CAN_NOT_BE_RESTORED = 'PASTORAL_CARE_CAN_NOT_BE_RESTORED',
  DOCTOR_CAN_NOT_BE_UPDATED = 'DOCTOR_CAN_NOT_BE_UPDATED',
  DOCTOR_CAN_NOT_BE_DELETED = 'DOCTOR_CAN_NOT_BE_DELETED',
  DOCTOR_CAN_NOT_BE_RESTORED = 'DOCTOR_CAN_NOT_BE_RESTORED',
  RESIDENT_CHECKLIST_NOT_FOUND = 'RESIDENT_CHECKLIST_NOT_FOUND',
  RESIDENT_CHECKLIST_CAN_NOT_BE_CREATED = 'RESIDENT_CHECKLIST_CAN_NOT_BE_CREATED',
  RESIDENT_CHECKLIST_CAN_NOT_BE_UPDATED = 'RESIDENT_CHECKLIST_CAN_NOT_BE_UPDATED',
  RESIDENT_CHECKLIST_CAN_NOT_BE_DELETED = 'RESIDENT_CHECKLIST_CAN_NOT_BE_DELETED',
  RESIDENT_CHECKLIST_CAN_NOT_BE_RESTORED = 'RESIDENT_CHECKLIST_CAN_NOT_BE_RESTORED',
  RESIDENT_DOCUMENTMANAGEMENT_CAN_NOT_BE_CREATED = 'RESIDENT_DOCUMENTMANAGEMENT_CAN_NOT_BE_CREATED',
  RESIDENT_DOCUMENTMANAGEMENT_FILE_ALREADY_EXISTS = 'RESIDENT_DOCUMENTMANAGEMENT_FILE_ALREADY_EXISTS',
  RESIDENT_DOCUMENTMANAGEMENT_NOT_FOUND = 'RESIDENT_DOCUMENTMANAGEMENT_NOT_FOUND',
  RESIDENT_DOCUMENTMANAGEMENT_CANNOT_BE_DELETED = 'RESIDENT_DOCUMENTMANAGEMENT_CANNOT_BE_DELETED',
  RESIDENT_DOCUMENTMANAGEMENT_CANNOT_BE_UPDATED = 'RESIDENT_DOCUMENTMANAGEMENT_CANNOT_BE_UPDATED',
  RESIDENT_DOCUMENT_GENERATION_CAN_NOT_BE_CREATED = 'RESIDENT_DOCUMENT_GENERATION_CAN_NOT_BE_CREATED',
  RESIDENT_DOCUMENT_GENERATION_INVALID_CODE = 'RESIDENT_DOCUMENT_GENERATION_INVALID_CODE',
  RESIDENT_DOCUMENT_GENERATION_FILE_ALREADY_EXISTS = 'RESIDENT_DOCUMENT_GENERATION_FILE_ALREADY_EXISTS',
  RESIDENT_DOCUMENT_GENERATION_NOT_FOUND = 'RESIDENT_DOCUMENT_GENERATION_NOT_FOUND',
  RESIDENT_DOCUMENT_GENERATION_CANNOT_BE_DELETED = 'RESIDENT_DOCUMENT_GENERATION_CANNOT_BE_DELETED',
  RESIDENT_DOCUMENT_GENERATION_CANNOT_BE_UPDATED = 'RESIDENT_DOCUMENT_GENERATION_CANNOT_BE_UPDATED',
  FORM_SUGGESTION_FILE_ALREADY_EXISTS = 'FORM_SUGGESTION_FILE_ALREADY_EXISTS',
  UTENSILS_NOT_FOUND = 'UTENSILS_NOT_FOUND',
  UTENSILS_CAN_NOT_BE_CREATED = 'UTENSILS_CAN_NOT_BE_CREATED',
  UTENSILS_CAN_NOT_BE_UPDATED = 'UTENSILS_CAN_NOT_BE_UPDATED',
  UTENSILS_CAN_NOT_BE_DELETED = 'UTENSILS_CAN_NOT_BE_DELETED',
  UTENSILS_CAN_NOT_BE_RESTORED = 'UTENSILS_CAN_NOT_BE_RESTORED',
  RESIDENT_CONTRACT_NOT_FOUND = 'RESIDENT_CONTRACT_NOT_FOUND',
  RESIDENT_CONTRACT_CAN_NOT_BE_CREATED = 'RESIDENT_CONTRACT_CAN_NOT_BE_CREATED',
  RESIDENT_CONTRACT_CAN_NOT_BE_UPDATED = 'RESIDENT_CONTRACT_CAN_NOT_BE_UPDATED',
  RESIDENT_CONTRACT_CAN_NOT_BE_RESTORED = 'RESIDENT_CONTRACT_CAN_NOT_BE_RESTORED',
  RESIDENT_CONTRACT_CAN_NOT_BE_DELETED = 'RESIDENT_CONTRACT_CAN_NOT_BE_DELETED',
  RESIDENT_OCCUPANCY_CAN_NOT_BE_RETRIEVED = 'RESIDENT_OCCUPANCY_CAN_NOT_BE_RETRIEVED',
  NURSING_TASK_CANNOT_BE_UPDATED = 'NURSING_TASK_CANNOT_BE_UPDATED',
  NURSING_TASK_CANNOT_BE_DELETED = 'NURSING_TASK_CANNOT_BE_DELETED',
  NURSING_TASK_DOCUMENTATION_NO_PERMISSION = 'NURSING_TASK_DOCUMENTATION_NO_PERMISSION',
  NURSING_TASK_DOCUMENTATION_CANNOT_BE_DELETED = 'NURSING_TASK_DOCUMENTATION_CANNOT_BE_DELETED',
  NURSING_TASK_DOCUMENTATION_CANNOT_BE_UPDATED = 'NURSING_TASK_DOCUMENTATION_CANNOT_BE_UPDATED',
  NURSING_TASK_DOCUMENTATION_CANNOT_BE_REVERTED = 'NURSING_TASK_DOCUMENTATION_CANNOT_BE_REVERTED',
  NURSING_TASK_DOCUMENTATION_CANNOT_BE_CREATED = 'NURSING_TASK_DOCUMENTATION_CANNOT_BE_CREATED',
  NURSING_TASK_DOCUMENTATION_CANNOT_BE_CREATED_DUPLICATE = 'NURSING_TASK_DOCUMENTATION_CANNOT_BE_CREATED_DUPLICATE',
  NURSING_TASK_DOCUMENTATION_IN_FUTURE_CANNOT_BE_UPDATED = 'NURSING_TASK_DOCUMENTATION_IN_FUTURE_CANNOT_BE_UPDATED',
  NURSING_TASK_DOCUMENTATION_WITH_FUTURE_TASK_CANNOT_BE_REVERTED = 'NURSING_TASK_DOCUMENTATION_WITH_FUTURE_TASK_CANNOT_BE_REVERTED',
  NURSING_TASK_DOCUMENTATION_OLDER_OPEN_TASK_EXISTS = 'NURSING_TASK_DOCUMENTATION_OLDER_OPEN_TASK_EXISTS',
  NURSING_HOME_CONFIGURATION_CAN_NOT_BE_CREATED = 'NURSING_HOME_CONFIGURATION_CAN_NOT_BE_CREATED',
  NURSING_HOME_CONFIGURATION_NOT_FOUND = 'NURSING_HOME_CONFIGURATION_NOT_FOUND',
  NURSING_HOME_CONFIGURATION_CAN_NOT_BE_UPDATED = 'NURSING_HOME_CONFIGURATION_CAN_NOT_BE_UPDATED',
  INVALID_USERNAME = 'INVALID_USERNAME',
  WOUND_THERAPY_CANNOT_BE_UPDATED = 'WOUND_THERAPY_CANNOT_BE_UPDATED',
  CARE_PLAN_3_CAN_NOT_BE_UPDATED = 'CARE_PLAN_3_CAN_NOT_BE_UPDATED',
  CARE_PLAN_2_CAN_NOT_BE_UPDATED = 'CARE_PLAN_2_CAN_NOT_BE_UPDATED',
  TIMEOS_ROOT_UNIT_DOES_NOT_EXIST = 'TIMEOS_ROOT_UNIT_DOES_NOT_EXIST',
  TIMEOS_PASSWORD_CANNOT_BE_UPDATED = 'TIMEOS_PASSWORD_CANNOT_BE_UPDATED',
  MOVEMENT_STATUS_CAN_NOT_BE_CREATED = 'MOVEMENT_STATUS_CAN_NOT_BE_CREATED',
  MOVEMENT_STATUS_NOT_FOUND = 'MOVEMENT_STATUS_NOT_FOUND',
  MOVEMENT_STATUS_CAN_NOT_BE_UPDATED = 'MOVEMENT_STATUS_CAN_NOT_BE_UPDATED',
  MOVEMENT_STATUS_CAN_NOT_BE_DELETED = 'MOVEMENT_STATUS_CAN_NOT_BE_DELETED',
  TIMEOS_CONFIGURATION_NOT_FOUND = 'TIMEOS_CONFIGURATION_NOT_FOUND',
  HOSPITAL_EXPORT_PDF_NOT_FOUND = 'HOSPITAL_EXPORT_PDF_NOT_FOUND',
  HOSPITAL_EXPORT_PDF_CAN_NOT_BE_CREATED = 'HOSPITAL_EXPORT_PDF_CAN_NOT_BE_CREATED',
  HOSPITAL_EXPORT_PDF_CAN_NOT_BE_UPDATED = 'HOSPITAL_EXPORT_PDF_CAN_NOT_BE_UPDATED',
  HOSPITAL_EXPORT_PDF_CAN_NOT_BE_DELETED = 'HOSPITAL_EXPORT_PDF_CAN_NOT_BE_DELETED',
  HOSPITAL_EXPORT_GROUP_PDF_NOT_FOUND = 'HOSPITAL_EXPORT_GROUP_PDF_NOT_FOUND',
  IDENTIFIER_COULD_NOT_BE_VALIDATED = 'IDENTIFIER_COULD_NOT_BE_VALIDATED',
  IDENTIFIER_IS_ALREADY_USED = 'IDENTIFIER_IS_ALREADY_USED',
  WOUND_NOT_FOUND = 'WOUND_NOT_FOUND',
  DELETION_NOT_ALLOWED = 'DELETION_NOT_ALLOWED',
  WOUND_CANNOT_BE_UPDATED = 'WOUND_CANNOT_BE_UPDATED',
  WOUND_REPORT_NOT_FOUND = 'WOUND_REPORT_NOT_FOUND',
  WOUND_THERAPY_NOT_FOUND = 'WOUND_THERAPY_NOT_FOUND',
  WOUND_THERAPY_CANNOT_BE_DELETED = 'WOUND_THERAPY_CANNOT_BE_DELETED',
  WOUND_CANNOT_BE_DELETED = 'WOUND_CANNOT_BE_DELETED',
  WOUND_DESCRIPTION_CANNOT_BE_UPDATED = 'WOUND_DESCRIPTION_CANNOT_BE_UPDATED',
  WOUND_INFORMATION_CANNOT_BE_UPDATED = 'WOUND_INFORMATION_CANNOT_BE_UPDATED',
  WOUND_ATTACHMENT_CAN_NOT_BE_CREATED = 'WOUND_ATTACHMENT_CAN_NOT_BE_CREATED',
  WOUND_ATTACHMENT_FILE_ALREADY_EXISTS = 'WOUND_ATTACHMENT_FILE_ALREADY_EXISTS',
  WOUND_ATTACHMENT_NOT_FOUND = 'WOUND_ATTACHMENT_NOT_FOUND',
  WOUND_ATTACHMENT_CANNOT_BE_DELETED = 'WOUND_ATTACHMENT_CANNOT_BE_DELETED',
  WOUND_ATTACHMENT_CANNOT_BE_UPDATED = 'WOUND_ATTACHMENT_CANNOT_BE_UPDATED',
  LAST_WOUND_DESCRIPTION_CANNOT_BE_DELETED = 'LAST_WOUND_DESCRIPTION_CANNOT_BE_DELETED',
  AQUA_CONFIGURATION_NOT_FOUND = 'AQUA_CONFIGURATION_NOT_FOUND',
  COMMON_MEDICATION_NOT_FOUND = 'COMMON_MEDICATION_NOT_FOUND',
  INSURANCE_NOT_FOUND = 'INSURANCE_NOT_FOUND',
  INSURANCE_CAN_NOT_BE_CREATED = 'INSURANCE_CAN_NOT_BE_CREATED',
  INSURANCE_CAN_NOT_BE_UPDATED = 'INSURANCE_CAN_NOT_BE_UPDATED',
  INSURANCE_DUPLICATE_NAME = 'INSURANCE_DUPLICATE_NAME',
  INSURANCE_DELETION_FAILED = 'INSURANCE_DELETION_FAILED',
  INSURANCE_CAN_NOT_BE_DELETED_AS_IN_USE = 'INSURANCE_CAN_NOT_BE_DELETED_AS_IN_USE',
  INSURANCES_CAN_NOT_BE_LOADED = 'INSURANCES_CAN_NOT_BE_LOADED',
  WELFARE_OFFICE_NOT_FOUND = 'WELFARE_OFFICE_NOT_FOUND',
  WELFARE_OFFICE_CAN_NOT_BE_CREATED = 'WELFARE_OFFICE_CAN_NOT_BE_CREATED',
  WELFARE_OFFICE_CAN_NOT_BE_UPDATED = 'WELFARE_OFFICE_CAN_NOT_BE_UPDATED',
  WELFARE_OFFICE_DUPLICATE_NAME = 'WELFARE_OFFICE_DUPLICATE_NAME',
  WELFARE_OFFICE_DELETION_FAILED = 'WELFARE_OFFICE_DELETION_FAILED',
  WELFARE_OFFICE_CAN_NOT_BE_DELETED_AS_IN_USE = 'WELFARE_OFFICE_CAN_NOT_BE_DELETED_AS_IN_USE',
  WELFARE_OFFICES_CAN_NOT_BE_LOADED = 'WELFARE_OFFICES_CAN_NOT_BE_LOADED',
  INVOICE_NOT_FOUND = 'INVOICE_NOT_FOUND',
  INVOICE_NOT_EDITABLE = 'INVOICE_NOT_EDITABLE',
  INVOICE_NOT_EDITABLE_AS_MEANWHILE_UPDATED = 'INVOICE_NOT_EDITABLE_AS_MEANWHILE_UPDATED',
  INVOICE_CAN_NOT_BE_UPDATED = 'INVOICE_CAN_NOT_BE_UPDATED',
  INVOICE_CAN_NOT_BE_SET_TO_DRAFT_AS_PAYMENTS_WHERE_MADE = 'INVOICE_CAN_NOT_BE_SET_TO_DRAFT_AS_PAYMENTS_WHERE_MADE',
  INVOICE_CAN_NOT_BE_SET_TO_DRAFT_AS_IT_IS_CANCELED = 'INVOICE_CAN_NOT_BE_SET_TO_DRAFT_AS_IT_IS_CANCELED',
  INVOICE_ALREADY_CANCELED = 'INVOICE_ALREADY_CANCELED',
  SOURCE_INVOICE_NOT_FOUND = 'SOURCE_INVOICE_NOT_FOUND',
  INVOICE_CAN_NOT_BE_CANCELED_AS_DRAFT = 'INVOICE_CAN_NOT_BE_CANCELED_AS_DRAFT',
  INVOICE_CANCELLATION_FAILED = 'INVOICE_CANCELLATION_FAILED',
  INVOICE_DELETION_FAILED = 'INVOICE_DELETION_FAILED',
  INVOICE_DUPLICATE_VOUCHER_NUMBER = 'INVOICE_DUPLICATE_VOUCHER_NUMBER',
  INVOICE_INVALID_SERVICE_PERIOD = 'INVOICE_INVALID_SERVICE_PERIOD',
  INVOICE_VERSION_INCREMENT_FAILED = 'INVOICE_VERSION_INCREMENT_FAILED',
  INVOICES_CAN_NOT_BE_LOADED = 'INVOICES_CAN_NOT_BE_LOADED',
  INVOICE_ITEM_NOT_FOUND = 'INVOICE_ITEM_NOT_FOUND',
  INVOICE_ITEM_CAN_NOT_BE_CREATED = 'INVOICE_ITEM_CAN_NOT_BE_CREATED',
  INVOICE_ITEM_CAN_NOT_BE_UPDATED = 'INVOICE_ITEM_CAN_NOT_BE_UPDATED',
  INVOICE_ITEM_DELETION_FAILED = 'INVOICE_ITEM_DELETION_FAILED',
  INVOICE_ITEMS_CAN_NOT_BE_LOADED = 'INVOICE_ITEMS_CAN_NOT_BE_LOADED',
  INVOICE_COST_ASSIGNMENT_NOT_FOUND = 'INVOICE_COST_ASSIGNMENT_NOT_FOUND',
  INVOICE_COST_ASSIGNMENT_CAN_NOT_BE_CREATED = 'INVOICE_COST_ASSIGNMENT_CAN_NOT_BE_CREATED',
  INVOICE_COST_ASSIGNMENT_CAN_NOT_BE_UPDATED = 'INVOICE_COST_ASSIGNMENT_CAN_NOT_BE_UPDATED',
  INVOICE_COST_ASSIGNMENT_DELETION_FAILED = 'INVOICE_COST_ASSIGNMENT_DELETION_FAILED',
  INVOICE_COST_ASSIGNMENTS_CAN_NOT_BE_LOADED = 'INVOICE_COST_ASSIGNMENTS_CAN_NOT_BE_LOADED',
  COST_BEARER_NOT_FOUND = 'COST_BEARER_NOT_FOUND',
  COST_BEARER_GET_OR_CREATE_FAILED = 'COST_BEARER_GET_OR_CREATE_FAILED',
  COST_BEARER_GET_ADDRESS_FAILED = 'COST_BEARER_GET_ADDRESS_FAILED',
  COST_BEARER_BALANCE_CAN_NOT_BE_UPDATED = 'COST_BEARER_BALANCE_CAN_NOT_BE_UPDATED',
  EXPECTED_PAYMENT_NOT_FOUND = 'EXPECTED_PAYMENT_NOT_FOUND',
  EXPECTED_PAYMENT_CAN_NOT_BE_UPDATED = 'EXPECTED_PAYMENT_CAN_NOT_BE_UPDATED',
  EXPECTED_PAYMENTS_CAN_NOT_BE_CREATED = 'EXPECTED_PAYMENTS_CAN_NOT_BE_CREATED',
  EXPECTED_PAYMENTS_CAN_NOT_BE_DELETED = 'EXPECTED_PAYMENTS_CAN_NOT_BE_DELETED',
  PAYMENT_NOT_FOUND = 'PAYMENT_NOT_FOUND',
  PAYMENT_CAN_NOT_BE_CREATED = 'PAYMENT_CAN_NOT_BE_CREATED',
  PAYMENT_DELETION_FAILED = 'PAYMENT_DELETION_FAILED',
  PAYMENT_DELETION_FAILED_AS_CONVERTED_INTO_BALANCE = 'PAYMENT_DELETION_FAILED_AS_CONVERTED_INTO_BALANCE',
  PAYMENTS_CAN_NOT_BE_LOADED = 'PAYMENTS_CAN_NOT_BE_LOADED',
  PAYMENTS_SUM_CAN_NOT_EXCEED_EXPECTED_AMOUNT = 'PAYMENTS_SUM_CAN_NOT_EXCEED_EXPECTED_AMOUNT',
  OPTIONAL_SERVICE_NOT_FOUND = 'OPTIONAL_SERVICE_NOT_FOUND',
  OPTIONAL_SERVICE_CAN_NOT_BE_CREATED = 'OPTIONAL_SERVICE_CAN_NOT_BE_CREATED',
  OPTIONAL_SERVICE_CAN_NOT_BE_UPDATED = 'OPTIONAL_SERVICE_CAN_NOT_BE_UPDATED',
  OPTIONAL_SERVICE_DELETION_FAILED = 'OPTIONAL_SERVICE_DELETION_FAILED',
  OPTIONAL_SERVICES_CAN_NOT_BE_LOADED = 'OPTIONAL_SERVICE_CAN_NOT_BE_LOADED',
  RESIDENT_INSURANCE_INVOICING_CONFIG_NOT_FOUND = 'RESIDENT_INSURANCE_INVOICING_CONFIG_NOT_FOUND',
  RESIDENT_INSURANCE_INVOICING_CONFIG_CAN_NOT_BE_LOADED = 'RESIDENT_INSURANCE_INVOICING_CONFIG_CAN_NOT_BE_LOADED',
  RESIDENT_INSURANCE_INVOICING_CONFIG_CAN_NOT_BE_CREATED = 'RESIDENT_INSURANCE_INVOICING_CONFIG_CAN_NOT_BE_CREATED',
  RESIDENT_INSURANCE_INVOICING_CONFIG_CAN_NOT_BE_DELETED = 'RESIDENT_INSURANCE_INVOICING_CONFIG_CAN_NOT_BE_DELETED',
  RESIDENT_INSURANCE_INVOICING_CONFIG_CAN_NOT_BE_UPDATED = 'RESIDENT_INSURANCE_INVOICING_CONFIG_CAN_NOT_BE_UPDATED',
  RESIDENT_INSURANCE_INVOICING_CONFIG_DUPLICATE_DATE = 'RESIDENT_INSURANCE_INVOICING_CONFIG_DUPLICATE_DATE',
  RESIDENT_INSURANCE_INVOICING_CONFIG_NOT_MOST_RESENT = 'RESIDENT_INSURANCE_INVOICING_CONFIG_NOT_MOST_RESENT',
  RESIDENT_WELFARE_OFFICE_INVOICING_CONFIG_NOT_FOUND = 'RESIDENT_WELFARE_OFFICE_INVOICING_CONFIG_NOT_FOUND',
  RESIDENT_WELFARE_OFFICE_INVOICING_CONFIG_CAN_NOT_BE_LOADED = 'RESIDENT_WELFARE_OFFICE_INVOICING_CONFIG_CAN_NOT_BE_LOADED',
  RESIDENT_WELFARE_OFFICE_INVOICING_CONFIG_CAN_NOT_BE_CREATED = 'RESIDENT_WELFARE_OFFICE_INVOICING_CONFIG_CAN_NOT_BE_CREATED',
  RESIDENT_WELFARE_OFFICE_INVOICING_CONFIG_CAN_NOT_BE_DELETED = 'RESIDENT_WELFARE_OFFICE_INVOICING_CONFIG_CAN_NOT_BE_DELETED',
  RESIDENT_WELFARE_OFFICE_INVOICING_CONFIG_CAN_NOT_BE_UPDATED = 'RESIDENT_WELFARE_OFFICE_INVOICING_CONFIG_CAN_NOT_BE_UPDATED',
  RESIDENT_WELFARE_OFFICE_INVOICING_CONFIG_NOT_MOST_RESENT = 'RESIDENT_WELFARE_OFFICE_INVOICING_CONFIG_NOT_MOST_RESENT',
  RESIDENT_WELFARE_OFFICE_INVOICING_CONFIG_DUPLICATE_DATE = 'RESIDENT_WELFARE_OFFICE_INVOICING_CONFIG_DUPLICATE_DATE',
  RESIDENT_PRIVATE_PAYER_INVOICING_CONFIG_NOT_FOUND = 'RESIDENT_PRIVATE_PAYER_INVOICING_CONFIG_NOT_FOUND',
  RESIDENT_PRIVATE_PAYER_INVOICING_CONFIG_CAN_NOT_BE_LOADED = 'RESIDENT_PRIVATE_PAYER_INVOICING_CONFIG_CAN_NOT_BE_LOADED',
  RESIDENT_PRIVATE_PAYER_INVOICING_CONFIG_CAN_NOT_BE_CREATED = 'RESIDENT_PRIVATE_PAYER_INVOICING_CONFIG_CAN_NOT_BE_CREATED',
  RESIDENT_PRIVATE_PAYER_INVOICING_CONFIG_CAN_NOT_BE_DELETED = 'RESIDENT_PRIVATE_PAYER_INVOICING_CONFIG_CAN_NOT_BE_DELETED',
  RESIDENT_PRIVATE_PAYER_INVOICING_CONFIG_NOT_MOST_RESENT = 'RESIDENT_PRIVATE_PAYER_INVOICING_CONFIG_NOT_MOST_RESENT',
  RESIDENT_MONTHLY_INCOMING_FUND_INVOICING_CONFIG_NOT_FOUND = 'RESIDENT_MONTHLY_INCOMING_FUND_INVOICING_CONFIG_NOT_FOUND',
  RESIDENT_MONTHLY_INCOMING_FUND_INVOICING_CONFIG_CAN_NOT_BE_LOADED = 'RESIDENT_MONTHLY_INCOMING_FUND_INVOICING_CONFIG_CAN_NOT_BE_LOADED',
  RESIDENT_MONTHLY_INCOMING_FUND_INVOICING_CONFIG_CAN_NOT_BE_CREATED = 'RESIDENT_MONTHLY_INCOMING_FUND_INVOICING_CONFIG_CAN_NOT_BE_CREATED',
  RESIDENT_MONTHLY_INCOMING_FUND_INVOICING_CONFIG_CAN_NOT_BE_DELETED = 'RESIDENT_MONTHLY_INCOMING_FUND_INVOICING_CONFIG_CAN_NOT_BE_DELETED',
  RESIDENT_MONTHLY_INCOMING_FUND_INVOICING_CONFIG_CAN_NOT_BE_UPDATED = 'RESIDENT_MONTHLY_INCOMING_FUND_INVOICING_CONFIG_CAN_NOT_BE_UPDATED',
  RESIDENT_MONTHLY_INCOMING_FUND_INVOICING_CONFIG_END_BEFORE_START = 'RESIDENT_MONTHLY_INCOMING_FUND_INVOICING_CONFIG_END_BEFORE_START',
  RESIDENT_OPTIONAL_SERVICE_INVOICING_CONFIG_NOT_FOUND = 'RESIDENT_OPTIONAL_SERVICE_INVOICING_CONFIG_NOT_FOUND',
  RESIDENT_OPTIONAL_SERVICE_INVOICING_CONFIG_CAN_NOT_BE_LOADED = 'RESIDENT_OPTIONAL_SERVICE_INVOICING_CONFIG_CAN_NOT_BE_LOADED',
  RESIDENT_OPTIONAL_SERVICE_INVOICING_CONFIG_CAN_NOT_BE_CREATED = 'RESIDENT_OPTIONAL_SERVICE_INVOICING_CONFIG_CAN_NOT_BE_CREATED',
  RESIDENT_OPTIONAL_SERVICE_INVOICING_CONFIG_CAN_NOT_BE_DELETED = 'RESIDENT_OPTIONAL_SERVICE_INVOICING_CONFIG_CAN_NOT_BE_DELETED',
  RESIDENT_OPTIONAL_SERVICE_INVOICING_CONFIG_CAN_NOT_BE_UPDATED = 'RESIDENT_OPTIONAL_SERVICE_INVOICING_CONFIG_CAN_NOT_BE_UPDATED',
  RESIDENT_OPTIONAL_SERVICE_INVOICING_CONFIG_END_BEFORE_START = 'RESIDENT_OPTIONAL_SERVICE_INVOICING_CONFIG_END_BEFORE_START',
  RESIDENT_FEEDING_TUBE_PERIOD_INVOICING_CONFIG_NOT_FOUND = 'RESIDENT_FEEDING_TUBE_PERIOD_INVOICING_CONFIG_NOT_FOUND',
  RESIDENT_FEEDING_TUBE_PERIOD_INVOICING_CONFIG_CAN_NOT_BE_LOADED = 'RESIDENT_FEEDING_TUBE_PERIOD_INVOICING_CONFIG_CAN_NOT_BE_LOADED',
  RESIDENT_FEEDING_TUBE_PERIOD_INVOICING_CONFIG_CAN_NOT_BE_CREATED = 'RESIDENT_FEEDING_TUBE_PERIOD_INVOICING_CONFIG_CAN_NOT_BE_CREATED',
  RESIDENT_FEEDING_TUBE_PERIOD_INVOICING_CONFIG_CAN_NOT_BE_DELETED = 'RESIDENT_FEEDING_TUBE_PERIOD_INVOICING_CONFIG_CAN_NOT_BE_DELETED',
  RESIDENT_FEEDING_TUBE_PERIOD_INVOICING_CONFIG_CAN_NOT_BE_UPDATED = 'RESIDENT_FEEDING_TUBE_PERIOD_INVOICING_CONFIG_CAN_NOT_BE_UPDATED',
  RESIDENT_FEEDING_TUBE_PERIOD_INVOICING_CONFIG_END_BEFORE_START = 'RESIDENT_FEEDING_TUBE_PERIOD_INVOICING_CONFIG_END_BEFORE_START',
  RESIDENT_INVOICING_REMARK_CAN_NOT_BE_FOUND = 'RESIDENT_INVOICING_REMARK_CAN_NOT_BE_FOUND',
  RESIDENT_INVOICING_REMARK_CAN_NOT_BE_UPDATED = 'RESIDENT_INVOICING_REMARK_CAN_NOT_BE_UPDATED',
  RESIDENT_INVOICING_REMARK_CAN_NOT_BE_CREATED = 'RESIDENT_INVOICING_REMARK_CAN_NOT_BE_CREATED',
  NURSING_HOME_INVOICING_COST_RATES_CONFIG_NOT_FOUND = 'NURSING_HOME_INVOICING_COST_RATES_CONFIG_NOT_FOUND',
  NURSING_HOME_INVOICING_COST_RATES_CONFIG_CAN_NOT_BE_LOADED = 'NURSING_HOME_INVOICING_COST_RATES_CONFIG_CAN_NOT_BE_LOADED',
  NURSING_HOME_INVOICING_COST_RATES_CONFIG_CAN_NOT_BE_CREATED = 'NURSING_HOME_INVOICING_COST_RATES_CONFIG_CAN_NOT_BE_CREATED',
  NURSING_HOME_INVOICING_COST_RATES_CONFIG_CAN_NOT_BE_DELETED = 'NURSING_HOME_INVOICING_COST_RATES_CONFIG_CAN_NOT_BE_DELETED',
  NURSING_HOME_INVOICING_COST_RATES_CONFIG_NOT_MOST_RESENT = 'NURSING_HOME_INVOICING_COST_RATES_CONFIG_NOT_MOST_RESENT',
  NEWS_NOT_FOUND = 'NEWS_NOT_FOUND',
  NEWS_CAN_NOT_BE_CREATED = 'NEWS_CAN_NOT_BE_CREATED',
  NEWS_CAN_NOT_BE_UPDATED = 'NEWS_CAN_NOT_BE_UPDATED',
  NEWS_DELETION_FAILED = 'NEWS_DELETION_FAILED',
  NEWS_CAN_NOT_GET = 'NEWS_CAN_NOT_GET',
  EVENT_NOT_FOUND = 'EVENT_NOT_FOUND',
  EVENT_CAN_NOT_BE_CREATED = 'EVENT_CAN_NOT_BE_CREATED',
  EVENT_CAN_NOT_BE_UPDATED = 'EVENT_CAN_NOT_BE_UPDATED',
  EVENT_DELETION_FAILED = 'EVENT_DELETION_FAILED',
  EVENT_CAN_NOT_GET = 'EVENT_CAN_NOT_GET',
  NURSING_HOME_HEADER_CANNOT_BE_CREATED = 'NURSING_HOME_HEADER_CANNOT_BE_CREATED',
  NURSING_HOME_HEADER_CANNOT_BE_FOUND = 'NURSING_HOME_HEADER_CANNOT_BE_FOUND',
  NURSING_HOME_HEADER_CANNOT_BE_DELETED = 'NURSING_HOME_HEADER_CANNOT_BE_DELETED',
  WOUND_THERAPY_ORDER_NOT_FOUND = 'WOUND_THERAPY_ORDER_NOT_FOUND',
  WOUND_THERAPY_ORDER_CANNOT_BE_UPDATED = 'WOUND_THERAPY_ORDER_CANNOT_BE_UPDATED',
  WOUND_THERAPY_ORDER_CANNOT_BE_DELETED = 'WOUND_THERAPY_ORDER_CANNOT_BE_DELETED',
  WOUND_THERAPY_ORDER_CANNOT_BE_CREATED = 'WOUND_THERAPY_ORDER_CANNOT_BE_CREATED',
  USERNAME_ALREADY_EXISTS = 'USERNAME_ALREADY_EXISTS',
  SEPA_EXPORT_CAN_NOT_BE_SAVED = 'SEPA_EXPORT_CAN_NOT_BE_SAVED',
  FIBU_EXPORT_CAN_NOT_BE_SAVED = 'FIBU_EXPORT_CAN_NOT_BE_SAVED',
  FIBU_CONFIG_ALREADY_EXISTS = 'FIBU_CONFIG_ALREADY_EXISTS',
  FIBU_CONFIG_NOT_FOUND = 'FIBU_CONFIG_NOT_FOUND',
  FIBU_CAN_NOT_BE_UPDATED = 'FIBU_CAN_NOT_BE_UPDATED',
  FIBU_CASH_EXPORT_CAN_NOT_BE_CREATED = 'FIBU_CASH_EXPORT_CAN_NOT_BE_CREATED',
  SEPA_POCKET_NOT_FOUND = 'SEPA_POCKET_NOT_FOUND',
  SEPA_POCKET_CAN_NOT_BE_SAVED = 'SEPA_POCKET_CAN_NOT_BE_SAVED',
  SEPA_POCKET_CAN_NOT_BE_UPDATED = 'SEPA_POCKET_CAN_NOT_BE_UPDATED',
  SEPA_POCKET_CAN_NOT_BE_DELETED = 'SEPA_POCKET_CAN_NOT_BE_DELETED',
  BOOKING_ACCOUNT_NOT_FOUND = 'BOOKING_ACCOUNT_NOT_FOUND',
  CASH_ITEM_NOT_FOUND = 'CASH_ITEM_NOT_FOUND',
  CASH_TRANSACTION_CAN_NOT_BE_UPDATED = 'CASH_TRANSACTION_CAN_NOT_BE_UPDATED',
  CASH_TRANSACTION_CAN_NOT_BE_LOADED = 'CASH_TRANSACTION_CAN_NOT_BE_LOADED',
  DOCUMENT_TEMPLATE_NOT_FOUND = 'DOCUMENT_TEMPLATE_NOT_FOUND',
  DOCUMENT_TEMPLATE_CAN_NOT_BE_CREATED = 'DOCUMENT_TEMPLATE_CAN_NOT_BE_CREATED',
  DOCUMENT_TEMPLATE_CANNOT_BE_DELETED = 'DOCUMENT_TEMPLATE_CANNOT_BE_DELETED',
  DOCUMENT_TEMPLATE_CANNOT_BE_UPDATED = 'DOCUMENT_TEMPLATE_CANNOT_BE_UPDATED',
  DOCUMENT_TEMPLATE_FILE_ALREADY_EXISTS = 'DOCUMENT_TEMPLATE_FILE_ALREADY_EXISTS',
}
